import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { DateConvert } from 'utilities';

const InfoSection = ({ data }) => {
  const InfoItem = ({ title, text }) => (
    <tr>
      <td className="align-top" style={{ fontSize: 14 }}>
        {title}
      </td>
      <td className="pl-4 pr-2 align-top" style={{ fontSize: 14 }}>
        :
      </td>
      <td className="align-top" style={{ fontSize: 14 }}>
        {text}
      </td>
    </tr>
  );
  return (
    <>
      <Row>
        <Col md={6}>
          <InfoItem
            title="Tanggal"
            text={
              data.tanggal ? DateConvert(new Date(data.tanggal)).detail : '-'
            }
          />
          <InfoItem title="Kode Customer" text={data.kode_customer ?? '-'} />
          <InfoItem title="Customer" text={data.nama_customer ?? '-'} />
        </Col>
        <Col mmd={6}>
          <InfoItem title="Kode Proyek" text={data.kode_proyek ?? '-'} />
          <InfoItem title="Proyek" text={data.nama_proyek ?? '-'} />
          <InfoItem title="Keterangan" text={data.keterangan ?? '-'} />
        </Col>
      </Row>
    </>
  );
};

export default InfoSection;
